import { Component, OnInit, Input } from '@angular/core';
import { Item } from '../../shared/sdk';
import { ItemService } from '../../items/item.service';
import { Observable, combineLatest, Subject, of } from 'rxjs';
import { filter, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-document-item-inventory-qty',
  templateUrl: './document-item-inventory-qty.component.html',
  styleUrls: ['./document-item-inventory-qty.component.css'],
})
export class DocumentItemInventoryQtyComponent implements OnInit {
  @Input() item: Observable<Item>;
  @Input() warehouseId: FormControl;

  hasInventory$: Observable<boolean>;
  inventory$: Observable<any>;
  private onDestroy$: Subject<void> = new Subject();

  constructor(private itemService: ItemService) {}

  ngOnInit() {
    const item$ = this.item;

    this.hasInventory$ = this.item.pipe(
      map((item) => item && item.trackInventory),
    );

    const warehouseId$ = this.warehouseId.valueChanges.pipe(
      startWith(this.warehouseId.value),
      filter((whId) => !!whId),
      takeUntil(this.onDestroy$),
    );

    this.inventory$ = combineLatest(item$, warehouseId$).pipe(
      switchMap(([item, warehouseId]) => {
        if (item && item.trackInventory) {
          return this.itemService
            .getInventory(item.id, { where: { warehouseId } })
            .pipe(
              map(({ body: inventories }) => {
                item.inventories = inventories;
                return { item, warehouseId };
              }),
            );
        } else {
          return of({ item: {} as Item, warehouseId: '' });
        }
      }),
      map(({ item, warehouseId }) => {
        return this.itemService.findInventory(item, warehouseId);
      }),
      takeUntil(this.onDestroy$),
    );
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
